// extracted by mini-css-extract-plugin
export var marginNegative = "_6p-5 _6p-3 _6p-1";
export var marginPositive = "_6p-4 _6p-3 _6p-1";
export var modalContent = "_6p-6";
export var samplesTable = "_6p-8";
export var samplesTableContainer = "_6p-7";
export var statBox = "_6p-a";
export var tableCell = "_6p-1";
export var tableCellCenter = "_6p-2 _6p-1";
export var tableCellRight = "_6p-3 _6p-1";
export var tableHeader = "_6p-0";
export var trackingNumber = "_6p-9";